import type { Tier } from '@/api/useLoggedUserQueues';
import type { Extension } from '@/data/Extension';

export type AgentCallAction = 'CALL' | 'FORWARD' | 'NONE';
export type AgentActivity =
  | 'AVAILABLE'
  | 'AVAILABLE_ON_DEMAND'
  | 'ON_BREAK'
  | 'IN_QUEUE_CALL'
  | 'DIRECT_CALL'
  | 'RECEIVING'
  | 'WRAP_UP'
  | 'LOGGED_OUT'
  | 'UNKNOWN';

export type ExtendedAgent = AgentDTO & {
  agentActivity: AgentActivity;
  tier: Tier;
  extension?: Extension | null;
};

export interface ExtendedAgentWithCallAction extends ExtendedAgent {
  callAction: AgentCallAction;
}

export enum AgentStatus {
  LOGGED_OUT = 'Logged Out',
  AVAILABLE_ON_DEMAND = 'Available (On Demand)',
  AVAILABLE = 'Available',
  ON_BREAK = 'On Break',
}

export enum AgentState {
  IDLE = 'Idle',
  WAITING = 'Waiting',
  RECEIVING = 'Receiving',
  IN_QUEUE_CALL = 'In a queue call',
}

export interface AgentResource {
  name: string;
  uuid: string;
  downtimeBegin: string | null;
  downtimeEnd: string | null;
  downtimeComment?: string | null;
  downtimeReason: 'BREAK' | 'WRAP_UP' | null;
  state: AgentState;
  status: AgentStatus;
  userUuid: string;
  lastStatusChange: string | null;
  lastBridgeStart: string | null;
}

export interface AgentDTO {
  name: string;
  uuid: string;
  downtimeBegin: number | null;
  downtimeEnd: number | null;
  downtimeComment?: string | null;
  downtimeReason: 'BREAK' | 'WRAP_UP' | null;
  state: AgentState;
  status: AgentStatus;
  userUuid: string;
  lastStatusChange: number | null;
  lastBridgeStart: number | null;
}
